// extracted by mini-css-extract-plugin
export default {"content":"F64bcevBgUFa9qU","empty-list-content":"ZHy_ctDdBTBdgRm"};